import axios from 'axios';
import APIHelper from 'dashboard/helper/APIHelper';
import { useAccount } from './useAccount';

export const useAxios = () => {
  const api = APIHelper(axios);
  const { accountId } = useAccount();

  // Create a wrapper that replaces :account_id placeholder
  const createRequest = (method, url, ...args) => {
    const processedUrl = url.replace(':account_id', accountId.value);
    return api[method](processedUrl, ...args);
  };

  return {
    get: (url, config) => createRequest('get', url, config),
    post: (url, data, config) => createRequest('post', url, data, config),
    put: (url, data, config) => createRequest('put', url, data, config),
    patch: (url, data, config) => createRequest('patch', url, data, config),
    delete: (url, config) => createRequest('delete', url, config),
  };
};
